import React, { useEffect, useState, useContext } from "react";
import { ConfigContext } from "../../Logica/context/ConfigContext";

const MateriasSelect = ({ categoria, onSeleccionarMateria }) => {
  const [materias, setMaterias] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const config = useContext(ConfigContext);

  useEffect(() => {
    if (!categoria || !config) return;

    const obtenerMaterias = async () => {
      setCargando(true);
      setError(null); // Reinicia error al cambiar categoría
      try {
        const url = `https://api.micrositec.com/api/mat?tipo=${categoria}`;
        const res = await fetch(url);
        const response = await res.json();

        if (response.ok && Array.isArray(response.data) && response.data.length > 0) {
          setMaterias(response.data);
        } else {
          setMaterias([]);
          setError("No hay actividad LiFE disponibles para esta categoría.");
        }
      } catch (error) {
        console.error("Error al obtener actividad LiFE:", error);
        setMaterias([]);
        setError("Ocurrió un error al cargar las actividades LiFE.");
      } finally {
        setCargando(false);
      }
    };

    obtenerMaterias();
  }, [categoria, config]);

  return (
    <div className="mt-3">
      {cargando && <p>Cargando actividades LiFE...</p>}

      {!cargando && error && (
        <p className="text-danger">{error}</p>
      )}

      {!cargando && materias.length > 0 && (
        <select
          className="form-select"
          onChange={(e) => {
            const codigoSeleccionado = e.target.value;
            const materiaObj = materias.find(
              (m) => String(m.ID) === codigoSeleccionado
            );
            onSeleccionarMateria(materiaObj || null);
          }}
          defaultValue=""
        >
          <option value="" disabled>
            Selecciona una materia
          </option>
          {materias.map((materia, index) => {
            const codigo = materia.ID ? materia.ID : `${index}`;
            const nombre =
              materia.CODE && materia.NAME
                ? `${materia.ID} - Grupo ${materia.GROUP} - ${materia.NAME.trim()}`
                : "(Sin nombre)";
            return (
              <option key={codigo} value={codigo}>
                {nombre}
              </option>
            );
          })}
        </select>
      )}
    </div>
  );
};

export default MateriasSelect;
